module.exports = __webpack_public_path__ + "line-awesome.5207295c5bccd6e7442c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/assets/vendors/line-awesome/fonts/line-awesome.svg?v=1.1.
// module id = ../../../../../src/assets/vendors/line-awesome/fonts/line-awesome.svg?v=1.1.
// module chunks = styles